<div class="card widget">
  <div>
    <div class="row">
      <div class="col-6 pr-0">
        <h4 class="city weather-city"><span class="weather-city-name">{{isMerckTenant ? 'Wetter heute' : weather?.location?.name}}</span></h4>
        <span class="temp-wrapper"><span class="temp-max weather-max-temp">{{$safeNavigationMigration(weather?.forecast?.forecastday?.[0]?.day?.maxtemp_c) | number : '1.0-0'}}&deg;</span><span class="temp-min weather-min-temp">/{{$safeNavigationMigration(weather?.forecast?.forecastday?.[0]?.day?.mintemp_c) | number : '1.0-0'}}&deg;</span>
      </span>
    </div>
    <div class="col-6">
      <img src="{{weather?.forecast?.forecastday?.[0]?.day?.condition?.icon}}" class="today-weather"></div>
    </div>
  </div>
  <div class="row">
    @for (day of $safeNavigationMigration(weather?.forecast?.forecastday)! | slice: 1; track day) {
      <div data-tooltip-no-anchor class="col-4 px-2 text-center weather-day-item">
        <img src="{{day?.day?.condition?.icon}}" class="forecast-icon">
        <div class="day-header weather-day-name">{{getDayName(day!.date)}}</div>
        <div class="weather-day-temp">
          <span class="forecast-temp-max">{{$safeNavigationMigration(day?.day?.maxtemp_c) | number : '1.0-0'}}&deg;</span><span class="forecast-temp-min">/{{$safeNavigationMigration(day?.day?.mintemp_c) | number : '1.0-0'}}&deg;</span>
        </div>
      </div>
    }
  </div>
</div>
